"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTable = exports.ListTableComponent = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const ListTable_1 = require("@reactionable/core/lib/crud/list/ListTable");
const Table_1 = tslib_1.__importDefault(require("react-bootstrap/Table"));
function ListTableComponent(_a) {
    var { head } = _a, bodyProps = tslib_1.__rest(_a, ["head"]);
    return (jsx_runtime_1.jsxs(Table_1.default, Object.assign({ striped: true, bordered: true, hover: true, responsive: true }, { children: [jsx_runtime_1.jsx(ListTable_1.ListTableHead, { head: head }, void 0),
            jsx_runtime_1.jsx(ListTable_1.ListTableBody, Object.assign({}, bodyProps), void 0)] }), void 0));
}
exports.ListTableComponent = ListTableComponent;
function ListTable(props) {
    return jsx_runtime_1.jsx(ListTable_1.ListTable, Object.assign({ Component: ListTableComponent }, props), void 0);
}
exports.ListTable = ListTable;
//# sourceMappingURL=ListTable.js.map